import React from 'react';

export default function DataTable({ columns, data, loading, onRowClick, emptyMessage }) {
  if (loading) return <div className="skeleton" style={{ height: '200px' }}></div>;
  if (!data || data.length === 0) return <p className="text-gray">{emptyMessage}</p>;

  return (
    <table className="data-table">
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.key}>{col.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, idx) => (
          <tr key={idx} onClick={() => onRowClick && onRowClick(row)} style={{ cursor: 'pointer' }}>
            {columns.map((col) => (
              <td key={col.key}>
                {col.render ? col.render(row[col.key], row) : row[col.key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
